@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.profile.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.profile.resources/"

@delegate:ResourceContentHash(-1_790_358_201)
internal val Res.string.profile_setting_invite: StringResource by lazy {
      StringResource("string:profile_setting_invite", "profile_setting_invite", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8933, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7041, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6237, 50),
      ))
    }

@delegate:ResourceContentHash(-1_219_271_330)
internal val Res.string.profile_setting_invite_sub: StringResource by lazy {
      StringResource("string:profile_setting_invite_sub", "profile_setting_invite_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8778, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6954, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6158, 78),
      ))
    }

@delegate:ResourceContentHash(-724_577_434)
internal val Res.string.profile_setting_language: StringResource by lazy {
      StringResource("string:profile_setting_language", "profile_setting_language", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9073, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7161, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6349, 56),
      ))
    }

@delegate:ResourceContentHash(1_178_165_252)
internal val Res.string.profile_setting_language_sub: StringResource by lazy {
      StringResource("string:profile_setting_language_sub", "profile_setting_language_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9000, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7096, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6288, 60),
      ))
    }

@delegate:ResourceContentHash(1_398_988_758)
internal val Res.string.profile_setting_legal: StringResource by lazy {
      StringResource("string:profile_setting_legal", "profile_setting_legal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9240, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7328, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6484, 49),
      ))
    }

@delegate:ResourceContentHash(-1_902_152_836)
internal val Res.string.profile_setting_legal_sub: StringResource by lazy {
      StringResource("string:profile_setting_legal_sub", "profile_setting_legal_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9138, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7218, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6406, 77),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.profile_setting_messages: StringResource by lazy {
      StringResource("string:profile_setting_messages", "profile_setting_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9415, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7483, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6599, 44),
      ))
    }

@delegate:ResourceContentHash(-743_723_771)
internal val Res.string.profile_setting_messages_sub: StringResource by lazy {
      StringResource("string:profile_setting_messages_sub", "profile_setting_messages_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9322, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7402, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6534, 64),
      ))
    }

@delegate:ResourceContentHash(-1_238_671_703)
internal val Res.string.profile_setting_moderation: StringResource by lazy {
      StringResource("string:profile_setting_moderation", "profile_setting_moderation", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9571, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7623, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6719, 50),
      ))
    }

@delegate:ResourceContentHash(-2_081_911_788)
internal val Res.string.profile_setting_moderation_sub: StringResource by lazy {
      StringResource("string:profile_setting_moderation_sub", "profile_setting_moderation_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9468, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7528, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6644, 74),
      ))
    }

@delegate:ResourceContentHash(1_647_667_767)
internal val Res.string.profile_setting_notifications: StringResource by lazy {
      StringResource("string:profile_setting_notifications", "profile_setting_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9768, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7784, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6860, 69),
      ))
    }

@delegate:ResourceContentHash(2_009_921_548)
internal val Res.string.profile_setting_notifications_sub: StringResource by lazy {
      StringResource("string:profile_setting_notifications_sub", "profile_setting_notifications_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9622, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7674, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6770, 89),
      ))
    }

@delegate:ResourceContentHash(-1_241_739_223)
internal val Res.string.profile_setting_orders: StringResource by lazy {
      StringResource("string:profile_setting_orders", "profile_setting_orders", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9945, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7937, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7001, 42),
      ))
    }

@delegate:ResourceContentHash(-1_779_708_000)
internal val Res.string.profile_setting_orders_sub: StringResource by lazy {
      StringResource("string:profile_setting_orders_sub", "profile_setting_orders_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9842, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7862, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6930, 70),
      ))
    }

@delegate:ResourceContentHash(-1_727_388_068)
internal val Res.string.profile_setting_privacy: StringResource by lazy {
      StringResource("string:profile_setting_privacy", "profile_setting_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10152, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8084, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7124, 55),
      ))
    }

@delegate:ResourceContentHash(1_129_881_994)
internal val Res.string.profile_setting_privacy_sub: StringResource by lazy {
      StringResource("string:profile_setting_privacy_sub", "profile_setting_privacy_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10008, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7988, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7044, 79),
      ))
    }

@delegate:ResourceContentHash(-294_600_607)
internal val Res.string.profile_setting_save_failed: StringResource by lazy {
      StringResource("string:profile_setting_save_failed", "profile_setting_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10228, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8156, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7180, 131),
      ))
    }

@delegate:ResourceContentHash(-1_930_098_991)
internal val Res.string.profile_setting_tickets: StringResource by lazy {
      StringResource("string:profile_setting_tickets", "profile_setting_tickets", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10528, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8404, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7392, 47),
      ))
    }

@delegate:ResourceContentHash(1_120_639_024)
internal val Res.string.profile_setting_tickets_sub: StringResource by lazy {
      StringResource("string:profile_setting_tickets_sub", "profile_setting_tickets_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10420, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8312, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7312, 79),
      ))
    }

@delegate:ResourceContentHash(102_028_561)
internal val Res.string.profile_setting_tour: StringResource by lazy {
      StringResource("string:profile_setting_tour", "profile_setting_tour", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10721, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8553, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7541, 40),
      ))
    }

@delegate:ResourceContentHash(-49_065_249)
internal val Res.string.profile_setting_tour_sub: StringResource by lazy {
      StringResource("string:profile_setting_tour_sub", "profile_setting_tour_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10592, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8452, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7440, 100),
      ))
    }

@delegate:ResourceContentHash(1_339_533_438)
internal val Res.string.profile_sign_out: StringResource by lazy {
      StringResource("string:profile_sign_out", "profile_sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10778, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8602, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7582, 36),
      ))
    }

@delegate:ResourceContentHash(1_895_856_833)
internal val Res.string.profile_stat_following: StringResource by lazy {
      StringResource("string:profile_stat_following", "profile_stat_following", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10815, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8647, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7619, 42),
      ))
    }

@delegate:ResourceContentHash(-1_842_427_983)
internal val Res.string.profile_stat_reviews: StringResource by lazy {
      StringResource("string:profile_stat_reviews", "profile_stat_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10882, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8694, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7662, 40),
      ))
    }

@delegate:ResourceContentHash(1_793_734_692)
internal val Res.string.profile_stat_saved: StringResource by lazy {
      StringResource("string:profile_stat_saved", "profile_stat_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10927, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8731, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7703, 34),
      ))
    }

@delegate:ResourceContentHash(-1_930_098_991)
internal val Res.string.profile_tickets: StringResource by lazy {
      StringResource("string:profile_tickets", "profile_tickets", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11086, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8866, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7810, 39),
      ))
    }

@delegate:ResourceContentHash(228_783_494)
internal val Res.string.profile_tickets_sub: StringResource by lazy {
      StringResource("string:profile_tickets_sub", "profile_tickets_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10990, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8774, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7738, 71),
      ))
    }

@delegate:ResourceContentHash(648_517_730)
internal val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11142, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8906, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7850, 33),
      ))
    }

@delegate:ResourceContentHash(-10_135_045)
internal val Res.string.profile_unsave_a11y: StringResource by lazy {
      StringResource("string:profile_unsave_a11y", "profile_unsave_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11184, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8936, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7884, 51),
      ))
    }

@delegate:ResourceContentHash(-1_209_859_932)
internal val Res.string.profile_version: StringResource by lazy {
      StringResource("string:profile_version", "profile_version", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11264, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9000, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7936, 51),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.saved_back_a11y: StringResource by lazy {
      StringResource("string:saved_back_a11y", "saved_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11320, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9052, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7988, 31),
      ))
    }

@delegate:ResourceContentHash(-724_555_368)
internal val Res.string.saved_empty_businesses: StringResource by lazy {
      StringResource("string:saved_empty_businesses", "saved_empty_businesses", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11360, 170),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9084, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8020, 126),
      ))
    }

@delegate:ResourceContentHash(212_184_962)
internal val Res.string.saved_empty_events: StringResource by lazy {
      StringResource("string:saved_empty_events", "saved_empty_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11531, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9227, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8147, 130),
      ))
    }

@delegate:ResourceContentHash(-1_509_729_775)
internal val Res.string.saved_empty_news: StringResource by lazy {
      StringResource("string:saved_empty_news", "saved_empty_news", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11682, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9346, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8278, 124),
      ))
    }

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.saved_event_am: StringResource by lazy {
      StringResource("string:saved_event_am", "saved_event_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11835, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9487, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8403, 26),
      ))
    }

@delegate:ResourceContentHash(-2_006_744_691)
internal val Res.string.saved_event_date_format: StringResource by lazy {
      StringResource("string:saved_event_date_format", "saved_event_date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11866, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9514, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8430, 71),
      ))
    }

@delegate:ResourceContentHash(129_066_643)
internal val Res.string.saved_event_free: StringResource by lazy {
      StringResource("string:saved_event_free", "saved_event_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11938, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9586, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8502, 32),
      ))
    }

@delegate:ResourceContentHash(-1_001_187_659)
internal val Res.string.saved_event_image_a11y: StringResource by lazy {
      StringResource("string:saved_event_image_a11y", "saved_event_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11979, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9623, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8535, 58),
      ))
    }

@delegate:ResourceContentHash(-668_863_442)
internal val Res.string.saved_event_open: StringResource by lazy {
      StringResource("string:saved_event_open", "saved_event_open", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12030, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9690, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8594, 40),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.saved_event_pm: StringResource by lazy {
      StringResource("string:saved_event_pm", "saved_event_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12083, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9739, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8635, 26),
      ))
    }

@delegate:ResourceContentHash(-1_093_289_626)
internal val Res.string.saved_section_past: StringResource by lazy {
      StringResource("string:saved_section_past", "saved_section_past", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12114, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9766, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8662, 34),
      ))
    }

@delegate:ResourceContentHash(-1_445_453_137)
internal val Res.string.saved_section_upcoming: StringResource by lazy {
      StringResource("string:saved_section_upcoming", "saved_section_upcoming", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12157, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9805, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8697, 42),
      ))
    }

@delegate:ResourceContentHash(-1_537_916_238)
internal val Res.string.saved_tab_businesses: StringResource by lazy {
      StringResource("string:saved_tab_businesses", "saved_tab_businesses", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12208, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9848, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8740, 44),
      ))
    }

@delegate:ResourceContentHash(1_438_319_466)
internal val Res.string.saved_tab_count: StringResource by lazy {
      StringResource("string:saved_tab_count", "saved_tab_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12265, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9893, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8785, 39),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.saved_tab_events: StringResource by lazy {
      StringResource("string:saved_tab_events", "saved_tab_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12305, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9933, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8825, 32),
      ))
    }

@delegate:ResourceContentHash(1_234_339_106)
internal val Res.string.saved_tab_news: StringResource by lazy {
      StringResource("string:saved_tab_news", "saved_tab_news", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12354, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9974, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8858, 30),
      ))
    }

@delegate:ResourceContentHash(1_793_734_692)
internal val Res.string.saved_title: StringResource by lazy {
      StringResource("string:saved_title", "saved_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12393, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10013, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8889, 27),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.settings_back_a11y: StringResource by lazy {
      StringResource("string:settings_back_a11y", "settings_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12449, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10049, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8917, 34),
      ))
    }

@delegate:ResourceContentHash(-1_898_004_463)
internal val Res.string.settings_discoverable_sub: StringResource by lazy {
      StringResource("string:settings_discoverable_sub", "settings_discoverable_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12492, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10084, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8952, 93),
      ))
    }

@delegate:ResourceContentHash(-655_808_579)
internal val Res.string.settings_discoverable_title: StringResource by lazy {
      StringResource("string:settings_discoverable_title", "settings_discoverable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12654, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10210, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9046, 51),
      ))
    }

@delegate:ResourceContentHash(522_934_200)
internal val Res.string.settings_section_account: StringResource by lazy {
      StringResource("string:settings_section_account", "settings_section_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12718, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10258, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9098, 44),
      ))
    }

@delegate:ResourceContentHash(-487_880_702)
internal val Res.string.settings_section_actions: StringResource by lazy {
      StringResource("string:settings_section_actions", "settings_section_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12779, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10299, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9143, 52),
      ))
    }

@delegate:ResourceContentHash(-1_925_185_604)
internal val Res.string.settings_section_admin: StringResource by lazy {
      StringResource("string:settings_section_admin", "settings_section_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12840, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10356, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9196, 38),
      ))
    }

@delegate:ResourceContentHash(1_779_782_442)
internal val Res.string.settings_section_business: StringResource by lazy {
      StringResource("string:settings_section_business", "settings_section_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12887, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10407, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9235, 45),
      ))
    }

@delegate:ResourceContentHash(-910_633_113)
internal val Res.string.settings_section_community: StringResource by lazy {
      StringResource("string:settings_section_community", "settings_section_community", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12945, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10457, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9281, 46),
      ))
    }

@delegate:ResourceContentHash(520_689_865)
internal val Res.string.settings_section_display: StringResource by lazy {
      StringResource("string:settings_section_display", "settings_section_display", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12996, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10508, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9328, 44),
      ))
    }

@delegate:ResourceContentHash(-81_531)
internal val Res.string.settings_section_help: StringResource by lazy {
      StringResource("string:settings_section_help", "settings_section_help", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13045, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10553, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9373, 45),
      ))
    }

@delegate:ResourceContentHash(1_126_795_605)
internal val Res.string.settings_section_notifications: StringResource by lazy {
      StringResource("string:settings_section_notifications", "settings_section_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13115, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10619, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9419, 58),
      ))
    }

@delegate:ResourceContentHash(-290_820_429)
internal val Res.string.settings_section_privacy: StringResource by lazy {
      StringResource("string:settings_section_privacy", "settings_section_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13178, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10678, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9478, 44),
      ))
    }

@delegate:ResourceContentHash(2_078_015_292)
internal val Res.string.settings_section_pro: StringResource by lazy {
      StringResource("string:settings_section_pro", "settings_section_pro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13239, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10735, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9523, 44),
      ))
    }

@delegate:ResourceContentHash(-1_284_382_610)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13288, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10780, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9568, 34),
      ))
    }

@delegate:ResourceContentHash(227_806_029)
internal val Res.string.terms_accept: StringResource by lazy {
      StringResource("string:terms_accept", "terms_accept", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13331, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10819, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9603, 44),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.terms_back_a11y: StringResource by lazy {
      StringResource("string:terms_back_a11y", "terms_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13388, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10868, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9648, 31),
      ))
    }

@delegate:ResourceContentHash(2_031_189_832)
internal val Res.string.terms_body: StringResource by lazy {
      StringResource("string:terms_body", "terms_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13428, 6502),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10900, 5330),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9680, 6090),
      ))
    }

@delegate:ResourceContentHash(726_375_594)
internal val Res.string.terms_consent_hint: StringResource by lazy {
      StringResource("string:terms_consent_hint", "terms_consent_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 19931, 206),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16231, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15771, 138),
      ))
    }

@delegate:ResourceContentHash(988_649_661)
internal val Res.string.terms_decline: StringResource by lazy {
      StringResource("string:terms_decline", "terms_decline", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 20367, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16547, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16051, 33),
      ))
    }

@delegate:ResourceContentHash(-1_638_096_692)
internal val Res.string.terms_decline_notice: StringResource by lazy {
      StringResource("string:terms_decline_notice", "terms_decline_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 20138, 228),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16378, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15910, 140),
      ))
    }

@delegate:ResourceContentHash(-583_112_920)
internal val Res.string.terms_intro: StringResource by lazy {
      StringResource("string:terms_intro", "terms_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 20417, 471),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16581, 351),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16085, 295),
      ))
    }

@delegate:ResourceContentHash(-2_006_846_461)
internal val Res.string.terms_summary_body: StringResource by lazy {
      StringResource("string:terms_summary_body", "terms_summary_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 20889, 1254),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16933, 894),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16381, 694),
      ))
    }

@delegate:ResourceContentHash(1_048_652_190)
internal val Res.string.terms_summary_disclaimer: StringResource by lazy {
      StringResource("string:terms_summary_disclaimer", "terms_summary_disclaimer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 22144, 216),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17828, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17076, 132),
      ))
    }

@delegate:ResourceContentHash(2_107_300_198)
internal val Res.string.terms_summary_title: StringResource by lazy {
      StringResource("string:terms_summary_title", "terms_summary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 22361, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18009, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17209, 51),
      ))
    }

@delegate:ResourceContentHash(1_398_988_758)
internal val Res.string.terms_title: StringResource by lazy {
      StringResource("string:terms_title", "terms_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 22421, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18049, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17261, 39),
      ))
    }

@delegate:ResourceContentHash(1_504_520_694)
internal val Res.string.terms_updated: StringResource by lazy {
      StringResource("string:terms_updated", "terms_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 22493, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18113, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17301, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("profile_setting_invite", Res.string.profile_setting_invite)
  map.put("profile_setting_invite_sub", Res.string.profile_setting_invite_sub)
  map.put("profile_setting_language", Res.string.profile_setting_language)
  map.put("profile_setting_language_sub", Res.string.profile_setting_language_sub)
  map.put("profile_setting_legal", Res.string.profile_setting_legal)
  map.put("profile_setting_legal_sub", Res.string.profile_setting_legal_sub)
  map.put("profile_setting_messages", Res.string.profile_setting_messages)
  map.put("profile_setting_messages_sub", Res.string.profile_setting_messages_sub)
  map.put("profile_setting_moderation", Res.string.profile_setting_moderation)
  map.put("profile_setting_moderation_sub", Res.string.profile_setting_moderation_sub)
  map.put("profile_setting_notifications", Res.string.profile_setting_notifications)
  map.put("profile_setting_notifications_sub", Res.string.profile_setting_notifications_sub)
  map.put("profile_setting_orders", Res.string.profile_setting_orders)
  map.put("profile_setting_orders_sub", Res.string.profile_setting_orders_sub)
  map.put("profile_setting_privacy", Res.string.profile_setting_privacy)
  map.put("profile_setting_privacy_sub", Res.string.profile_setting_privacy_sub)
  map.put("profile_setting_save_failed", Res.string.profile_setting_save_failed)
  map.put("profile_setting_tickets", Res.string.profile_setting_tickets)
  map.put("profile_setting_tickets_sub", Res.string.profile_setting_tickets_sub)
  map.put("profile_setting_tour", Res.string.profile_setting_tour)
  map.put("profile_setting_tour_sub", Res.string.profile_setting_tour_sub)
  map.put("profile_sign_out", Res.string.profile_sign_out)
  map.put("profile_stat_following", Res.string.profile_stat_following)
  map.put("profile_stat_reviews", Res.string.profile_stat_reviews)
  map.put("profile_stat_saved", Res.string.profile_stat_saved)
  map.put("profile_tickets", Res.string.profile_tickets)
  map.put("profile_tickets_sub", Res.string.profile_tickets_sub)
  map.put("profile_title", Res.string.profile_title)
  map.put("profile_unsave_a11y", Res.string.profile_unsave_a11y)
  map.put("profile_version", Res.string.profile_version)
  map.put("saved_back_a11y", Res.string.saved_back_a11y)
  map.put("saved_empty_businesses", Res.string.saved_empty_businesses)
  map.put("saved_empty_events", Res.string.saved_empty_events)
  map.put("saved_empty_news", Res.string.saved_empty_news)
  map.put("saved_event_am", Res.string.saved_event_am)
  map.put("saved_event_date_format", Res.string.saved_event_date_format)
  map.put("saved_event_free", Res.string.saved_event_free)
  map.put("saved_event_image_a11y", Res.string.saved_event_image_a11y)
  map.put("saved_event_open", Res.string.saved_event_open)
  map.put("saved_event_pm", Res.string.saved_event_pm)
  map.put("saved_section_past", Res.string.saved_section_past)
  map.put("saved_section_upcoming", Res.string.saved_section_upcoming)
  map.put("saved_tab_businesses", Res.string.saved_tab_businesses)
  map.put("saved_tab_count", Res.string.saved_tab_count)
  map.put("saved_tab_events", Res.string.saved_tab_events)
  map.put("saved_tab_news", Res.string.saved_tab_news)
  map.put("saved_title", Res.string.saved_title)
  map.put("settings_back_a11y", Res.string.settings_back_a11y)
  map.put("settings_discoverable_sub", Res.string.settings_discoverable_sub)
  map.put("settings_discoverable_title", Res.string.settings_discoverable_title)
  map.put("settings_section_account", Res.string.settings_section_account)
  map.put("settings_section_actions", Res.string.settings_section_actions)
  map.put("settings_section_admin", Res.string.settings_section_admin)
  map.put("settings_section_business", Res.string.settings_section_business)
  map.put("settings_section_community", Res.string.settings_section_community)
  map.put("settings_section_display", Res.string.settings_section_display)
  map.put("settings_section_help", Res.string.settings_section_help)
  map.put("settings_section_notifications", Res.string.settings_section_notifications)
  map.put("settings_section_privacy", Res.string.settings_section_privacy)
  map.put("settings_section_pro", Res.string.settings_section_pro)
  map.put("settings_title", Res.string.settings_title)
  map.put("terms_accept", Res.string.terms_accept)
  map.put("terms_back_a11y", Res.string.terms_back_a11y)
  map.put("terms_body", Res.string.terms_body)
  map.put("terms_consent_hint", Res.string.terms_consent_hint)
  map.put("terms_decline", Res.string.terms_decline)
  map.put("terms_decline_notice", Res.string.terms_decline_notice)
  map.put("terms_intro", Res.string.terms_intro)
  map.put("terms_summary_body", Res.string.terms_summary_body)
  map.put("terms_summary_disclaimer", Res.string.terms_summary_disclaimer)
  map.put("terms_summary_title", Res.string.terms_summary_title)
  map.put("terms_title", Res.string.terms_title)
  map.put("terms_updated", Res.string.terms_updated)
}
